import { render, staticRenderFns } from "./subCategoryDelete.vue?vue&type=template&id=0160e7a3&"
import script from "./subCategoryDelete.vue?vue&type=script&lang=js&"
export * from "./subCategoryDelete.vue?vue&type=script&lang=js&"
import style0 from "./subCategoryDelete.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports